var _path, _g, _rect, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2, _path12, _path13, _rect3, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideochamadaPerdaConexao = function SvgVideochamadaPerdaConexao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 356,
    viewBox: "0 0 528 356",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_7567)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.55 61.6219C252.641 84.8912 190.153 58.4224 146.66 55.792C94.9894 52.667 70.6878 85.9191 54.7738 143.906C38.9105 201.708 75.5713 256.255 117.843 291.057C140.245 309.501 166.782 321.799 192.58 322.741C241.306 329.621 312.683 326.098 337.613 326.098C389.847 326.098 453.624 322.885 478.129 255.906C502.065 190.485 458.507 138.079 423.541 94.7764C389.451 52.5583 347.816 2.28818 302.46 38.3526C294.231 47.4235 302.46 38.3526 277.55 61.6219Z",
    fill: "#ECF0FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 61.6219C252.641 84.8912 190.153 58.4224 146.66 55.792C94.9894 52.667 70.6878 85.9191 54.7738 143.906C38.9105 201.708 75.5712 256.255 117.843 291.057C140.245 309.501 166.782 321.799 192.58 322.741C241.306 329.621 312.683 326.098 337.613 326.098C389.847 326.098 453.624 322.885 478.129 255.906C502.065 190.485 458.507 138.079 423.541 94.7764C389.451 52.5583 347.816 2.28818 302.46 38.3526C294.231 47.4235 302.46 38.3526 277.55 61.6219Z",
    fill: "url(#paint0_linear_768_7567)",
    fillOpacity: 0.25,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.165,
    y: 281.902,
    width: 48.825,
    height: 2.03667,
    fill: "url(#paint1_radial_768_7567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.01 283.001C430.964 278.954 434.873 272.139 434.873 264.414C434.873 261.548 434.335 258.808 433.355 256.288C438.617 251.431 447.84 235.451 431.41 223.78C432.572 218.061 434.975 208.583 422.11 201.768C422.885 198.791 423.04 189.078 411.88 189.078C400.72 189.078 400.642 200.515 402.502 201.768C392.195 203.088 389.947 216.965 393.435 223.78C380.26 233.023 382.895 249.473 391.447 255.896C390.367 258.523 389.772 261.399 389.772 264.414C389.772 272.139 393.681 278.954 399.635 283.001C407.075 283.001 421.335 283.001 425.01 283.001Z",
    fill: "#50BBAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.827 219.957V271.715L425.461 264.113L425.699 264.516L412.827 272.262V283.001H412.362V272.169L412.286 272.04L412.362 271.995V250.578L412.334 250.606L402.572 240.602L402.903 240.272L412.362 249.965V219.957H412.827Z",
    fill: "#24252E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 423.968,
    y: 284.219,
    width: 35.175,
    height: 1.45167,
    fill: "url(#paint2_radial_768_7567)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.513 285.001C454.802 282.117 457.618 277.26 457.618 271.753C457.618 269.711 457.231 267.758 456.524 265.962C460.316 262.5 466.96 251.11 455.123 242.791C455.961 238.715 457.692 231.959 448.423 227.102C448.982 224.98 449.093 218.057 441.053 218.057C433.013 218.057 432.957 226.208 434.297 227.102C426.872 228.042 425.252 237.933 427.765 242.791C418.273 249.379 420.172 261.104 426.333 265.682C425.555 267.555 425.126 269.605 425.126 271.753C425.126 277.26 427.942 282.117 432.232 285.001C437.592 285.001 447.865 285.001 450.513 285.001Z",
    fill: "#50BBAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.736 240.064V276.955L450.837 271.537L451.009 271.825L441.736 277.345V285H441.401V277.28L441.346 277.188L441.401 277.155V261.89L441.381 261.91L434.348 254.779L434.586 254.544L441.401 261.453V240.064H441.736Z",
    fill: "#24252E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.277 102.55C176.999 102.55 171.099 108.45 171.099 115.728V255.201C171.099 262.479 176.999 268.379 184.277 268.379H351.583C358.862 268.379 364.762 262.479 364.762 255.201V115.728C364.762 108.45 358.862 102.55 351.583 102.55H184.277Z",
    fill: "#C5D4FF",
    stroke: "#96B6FF",
    strokeWidth: 5.27145
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.317 115.217C173.317 109.394 178.038 104.674 183.86 104.674H351.739C357.562 104.674 362.282 109.394 362.282 115.217V126.401H173.317V115.217Z",
    fill: "#96B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.679 118.523C190.142 118.523 191.328 117.255 191.328 115.69C191.328 114.126 190.142 112.857 188.679 112.857C187.216 112.857 186.03 114.126 186.03 115.69C186.03 117.255 187.216 118.523 188.679 118.523Z",
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.26,
    y: 112.857,
    width: 114.788,
    height: 7.55473,
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.552 118.297C197.022 118.297 198.214 117.028 198.214 115.463C198.214 113.898 197.022 112.629 195.552 112.629C194.082 112.629 192.891 113.898 192.891 115.463C192.891 117.028 194.082 118.297 195.552 118.297Z",
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.593 118.373C204.063 118.373 205.255 117.104 205.255 115.539C205.255 113.974 204.063 112.705 202.593 112.705C201.123 112.705 199.932 113.974 199.932 115.539C199.932 117.104 201.123 118.373 202.593 118.373Z",
    fill: "#007AF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.306 204.18C282.329 205.539 281.134 208.268 281.134 208.268C280.801 208.919 278.743 211.455 274.955 215.876C258.257 211.54 252.126 197.406 250.157 190.909C254.474 187.182 256.936 185.166 257.531 184.861C257.545 184.861 260.179 183.441 261.698 180.694C263.217 177.947 262.589 174.881 262.589 174.881C261.29 167.38 260.325 161.929 259.683 158.539C259.683 158.539 259.312 155.572 256.57 153.129C253.827 150.692 250.476 150.898 250.476 150.898L230.688 150.889C224.407 150.889 221.28 153.931 221.317 160.016C220.056 184.871 228.152 206.027 245.605 223.48C259.786 237.66 279.31 244.823 303.706 244.823C304.128 244.823 304.878 244.762 305.942 244.64C311.989 244.655 315.018 241.532 315.018 235.27V215.632C315.018 215.632 315.299 212.89 313.091 209.89C310.878 206.889 307.466 206.435 307.466 206.435C302.06 205.373 296.65 204.332 291.236 203.313C291.236 203.313 288.283 202.82 285.311 204.18H285.306Z",
    fill: "#96B6FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.504 162.851L107.874 162.851C106.26 162.851 104.692 162.317 103.413 161.333C100.483 159.077 99.0172 156.251 99.0172 152.855C99.0172 149.279 100.775 146.422 104.292 144.285C105.437 143.589 106.75 143.221 108.09 143.221L182.504 143.221C184.384 143.221 186.191 143.945 187.552 145.242C189.769 147.357 190.877 149.955 190.877 153.036C190.877 156.117 189.769 158.715 187.552 160.83C186.191 162.127 184.384 162.851 182.504 162.851Z",
    fill: "#007AF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.369 158.591C163.541 158.591 161.248 156.297 161.248 153.467C161.248 150.638 163.541 148.344 166.369 148.344C169.197 148.344 171.49 150.638 171.49 153.467C171.49 156.297 169.197 158.591 166.369 158.591Z",
    fill: "#C5D4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.789 158.591C141.961 158.591 139.668 156.297 139.668 153.467C139.668 150.638 141.961 148.344 144.789 148.344C147.617 148.344 149.909 150.638 149.909 153.467C149.909 156.297 147.617 158.591 144.789 158.591Z",
    fill: "#C5D4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.208 158.591C120.38 158.591 118.087 156.297 118.087 153.467C118.087 150.638 120.38 148.344 123.208 148.344C126.036 148.344 128.328 150.638 128.328 153.467C128.328 156.297 126.036 158.591 123.208 158.591Z",
    fill: "#C5D4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0286 269.629C100.858 313.578 99.8688 225.316 188.739 217.478",
    stroke: "#F888AE",
    strokeWidth: 17.5793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 228.17L254.186 219.472C258.717 218.108 261.285 213.329 259.921 208.797C258.557 204.265 253.778 201.697 249.246 203.061L220.348 211.759L225.288 228.17Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.697 199.631L245.595 190.933C250.127 189.569 252.695 184.789 251.331 180.258C249.967 175.726 245.187 173.158 240.655 174.522L211.757 183.22L216.697 199.631Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.875 239.74L182.199 250.478C175.105 252.613 167.624 248.594 165.489 241.5L154.751 205.824C152.616 198.731 156.636 191.25 163.729 189.115L199.405 178.377L217.875 239.74Z",
    fill: "#F888AE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.1772,
    height: 72.279,
    rx: 2.23543,
    transform: "matrix(0.957565 -0.288216 -0.288216 -0.957565 218.95 243.307)",
    fill: "#F888AE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M351.13 174.186C409.371 162.477 407.308 178.218 456.543 174.186C513.494 169.523 517.485 124.307 517.485 113.76",
    stroke: "#F888AE",
    strokeWidth: 17.5793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.632 216.042L353.411 205.649C360.524 203.583 364.616 196.142 362.55 189.028L352.157 153.25C350.091 146.136 342.649 142.044 335.536 144.111L299.757 154.503L317.632 216.042Z",
    fill: "#F888AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 318.67,
    y: 219.619,
    width: 11.1772,
    height: 72.279,
    rx: 2.23543,
    transform: "rotate(163.803 318.67 219.619)",
    fill: "#F888AE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.034 110.596C289.6 109.469 290.753 108.757 292.015 108.757L303.125 108.757C305.819 108.757 307.401 111.786 305.862 113.997L298.3 124.862L306.95 124.862C309.829 124.862 311.165 128.435 308.992 130.324L283.605 152.383C281.032 154.619 277.254 151.686 278.781 148.639L286.709 137.573L280.542 137.573C278.226 137.573 276.721 135.134 277.76 133.064L289.034 110.596Z",
    fill: "#FF8C54"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.552 121.671C219.535 120.925 218.184 120.816 217.061 121.39L205.046 127.529C202.647 128.755 202.617 132.172 204.993 133.441L216.671 139.674L208.968 143.61C206.404 144.92 206.841 148.71 209.636 149.403L242.279 157.495C245.588 158.315 247.618 153.984 244.871 151.965L234.898 144.635L240.389 141.829C242.451 140.775 242.681 137.919 240.815 136.548L220.552 121.671Z",
    fill: "#FF8C54"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.643 277.458C324.535 278.35 325.854 278.661 327.051 278.264L339.855 274.009C342.412 273.159 338.42 271.294 336.262 269.681L322.431 259.786L335.178 255.55C337.911 254.642 337.428 251.191 334.77 250.085L307.574 238.765C304.427 237.454 301.766 241.429 304.177 243.839L312.929 252.592L307.077 254.536C304.879 255.267 304.22 258.056 305.859 259.692L323.643 277.458Z",
    fill: "#FF8C54"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.034 288.036C250.246 289.021 248.97 289.477 247.736 289.215L239.766 286.18C237.13 285.62 236.213 282.328 238.178 280.485L247.834 271.431L239.373 269.632C236.556 269.033 235.993 265.26 238.512 263.865L265.65 247.479C268.632 245.827 271.718 249.481 269.59 252.144L259.734 262.304L264.95 263.415C267.215 263.897 268.18 266.595 266.733 268.404L251.034 288.036Z",
    fill: "#FF8C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_768_7567",
    x1: 268,
    y1: 327,
    x2: 268,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_768_7567",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(412.578 282.921) rotate(90) scale(1.01834 24.4125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_768_7567",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(441.556 284.945) rotate(90) scale(0.725834 17.5875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_7567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 528,
    height: 356,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideochamadaPerdaConexao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/videochamada-perda-conexao.407ae237.svg";
export { ForwardRef as ReactComponent };